import type { Product } from 'reactApp/types/Billing';
import { useSwitchProducts } from 'reactApp/ui/TariffSectionNew/hooks/useSwitchProducts';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import type { TariffsByTabProductsType } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';
import { getMonthProductPrice } from 'reactApp/utils/priceHelpers';

interface UsePriceDif {
    products?: TariffsByTabProductsType;
    familyProducts?: TariffsByTabProductsType;
    activeTab?: ETabsName;
}

const createEmptyProduct = (): Product => ({
    price: 0,
    id: '',
    period: '',
    available: false,
    isPromo: false,
    hasTrial: false,
    hasDiscount: false,
    space: {
        original: 0,
        space: 0,
        units: 'GB',
        value: '',
    },
    turbo: false,
});

const initialProducts: TariffsByTabProductsType = {
    yearProduct: createEmptyProduct(),
};

export const usePriceDif = ({ products, familyProducts, activeTab }: UsePriceDif): number => {
    const { product } = useSwitchProducts({
        products: products || initialProducts,
        activeTab,
        withSwitch: false,
    });
    const { product: familyProduct } = useSwitchProducts({
        products: familyProducts || initialProducts,
        activeTab,
        withSwitch: false,
    });

    if (!familyProduct || !product) {
        return 0;
    }

    return Math.abs(Math.trunc(getMonthProductPrice(product) - getMonthProductPrice(familyProduct)));
};
